import React, { Component } from 'react';
import '../assets/css/packageconfirmation.css'
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import { withStyles } from "@material-ui/core/styles";
import Header from '../components/HeaderComponent';
import PackageDetailsComponent from '../components/PackageDetailsComponent';
import FormComponent from '../components/FormComponent';
import MuthootFormComponent from '../components/MuthootFormComponent';
import useDataStore from '../store/dataStore';
import queryString from 'query-string';
import { getBaseUrl } from '../helpers/razorpay';

class PackageConfirmationComponent extends Component {
  handleClick() { }

  constructor(props) {
    super(props);

    function getData(props) {
      try {
        return props.location.state.params
      }
      catch (e) {
      }
    }

    let selectedPackage = getData(this.props);
    let needsFetch = false;
    if (!selectedPackage) {
      const parsed = queryString.parse(window.location.search);
      const packageName = parsed.PackageName || parsed.packageName;
      if (packageName) {
        const packageNameLower = decodeURIComponent(packageName).replace(/^["']|["']$/g, '').toLowerCase();
        const vendorData = useDataStore.getState().data || {};
        const packages = vendorData.packages || [];
        const matchedPackage = packages.find(pkg => {
          if (pkg.title && pkg.title.toLowerCase() === packageNameLower) return true;
          if (pkg.id && pkg.id.toString().toLowerCase() === packageNameLower) return true;
          if (pkg.urlSlug && pkg.urlSlug.toLowerCase() === packageNameLower) return true;
          return false;
        });
        if (matchedPackage) {
          selectedPackage = { packageDetails: matchedPackage, isAuthentic: true };
        } else {
          needsFetch = true;
        }
      }
    }
    const isValidate = selectedPackage?.packageDetails?.isValidate === true;
    this.state = {
      selectedPackage,
      hidePackageDetails: false,
      hideRenewalSearch: isValidate,
      prefillData: selectedPackage.prefillData || null,
      loading: needsFetch
    }

  }

  async componentDidMount() {
    if (this.state.loading) {
      const parsed = queryString.parse(window.location.search);
      const packageName = parsed.PackageName || parsed.packageName;
      let source = parsed.utm_source || localStorage.getItem('source') || 'default';
      try {
        const resConfig = await fetch(`${getBaseUrl()}/patientswebapp/affinity/vendorConfigrations?source=${source}`).then(t => t.json());
        useDataStore.setState(resConfig);
        const vendorData = resConfig.data || {};
        const packages = vendorData.packages || [];
        const packageNameLower = decodeURIComponent(packageName).replace(/^["']|["']$/g, '').toLowerCase();
        const matchedPackage = packages.find(pkg => {
          if (pkg.title && pkg.title.toLowerCase() === packageNameLower) return true;
          if (pkg.id && pkg.id.toString().toLowerCase() === packageNameLower) return true;
          if (pkg.urlSlug && pkg.urlSlug.toLowerCase() === packageNameLower) return true;
          return false;
        });
        if (matchedPackage) {
          this.setState({
            selectedPackage: { packageDetails: matchedPackage, isAuthentic: true },
            hideRenewalSearch: matchedPackage.isValidate === true,
            loading: false
          });
        } else {
          this.setState({ loading: false });
        }
      } catch (e) {
        console.error('Error fetching vendor config on refresh:', e);
        this.setState({ loading: false });
      }
    }
  }

  render() {
    if (this.state.loading) {
      return (<div style={{ textAlign: 'center', padding: '40px' }}>Loading...</div>)
    }
    if (!this.state.selectedPackage || !this.state.selectedPackage.packageDetails) {
      this.props.history.push('/')
      return (<div></div>)
    }
    let contactNumber = this.state.selectedPackage.packageDetails.contactPhoneNumber || "080 4568 6596";
    let contactEmail= this.state.selectedPackage.packageDetails.contactEmail || "doctorconsultations@medibuddy.in"
    const prefillData = this.state.prefillData || this.state.selectedPackage.prefillData;
    const { classes } = this.props;
      return (
        <div className="confirmation">
          <Header />
          <Container className={classes.root}>
            <Grid container spacing={4}>
              <Grid item xs={12} sm={7} md={6} style={{ display: this.state.hidePackageDetails ? 'none' : 'block' }}>
                <PackageDetailsComponent selectedPackage={this.state.selectedPackage.packageDetails}
                  subId={this.state.selectedPackage.subId}
                />
              </Grid>
              <Grid item xs={12} sm={this.state.hidePackageDetails ? 12 : 5} md={this.state.hidePackageDetails ? 12 : 6}>
                {this.state.selectedPackage.packageDetails.useDynamicForm ? (
                  <MuthootFormComponent selectedPackage={this.state.selectedPackage.packageDetails}
                    subId={this.state.selectedPackage.subId}
                    prefillData={prefillData}
                    baseURl={this.state.selectedPackage.packageDetails.baseURl}
                    onFormPageChange={(page) => {
                      const showOnPages = this.state.selectedPackage.packageDetails.showPackageDetailsOnPages || [1];
                      this.setState({
                        hidePackageDetails: !showOnPages.includes(page),
                        hideRenewalSearch: page === 0 || !showOnPages.includes(page)
                      });
                    }}
                  />
                ) : (
                  <FormComponent selectedPackage={this.state.selectedPackage.packageDetails}
                    subId={this.state.selectedPackage.subId}
                    prefillData={prefillData}
                    baseURl={this.state.selectedPackage.packageDetails.baseURl}
                  />
                )}
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                {!this.state.selectedPackage.packageDetails
                  .hideDefaultContactFooterInPlanDetails && (
                  <>
                    <div className="footer">
                      <h3>Thank you for choosing MediBuddy</h3>
                    </div>
                    <Grid container spacing={1} alignItems="center">
                      <Grid item xs={12} sm={6} md={4} style={{ display:'flex', alignItems:'center', justifyContent:'center' }}>
                        <span style={{ fontWeight: "bold" }}>Contact us </span>
                        <div className="fa fa-phone fa-lg">
                          :{" "} 
                          <a href>
                            {contactNumber}
                            </a>
                        </div>
                      </Grid>
                      {!this.state.selectedPackage.packageDetails.hideDefaultEmailInPlanDetails && (
                        <Grid item xs={12} sm={6} md={4} style={{ display:'flex', alignItems:'center', justifyContent:'center' }}>
                          <div
                            className="fa fa-envelope fa-lg"
                            style={{ marginLeft: "10px" }}
                          >
                            :<a href>{contactEmail}</a>
                          </div>
                        </Grid>
                      )}
                    </Grid>
                  </>
                )}
              </Grid>
            </Grid>
          </Container>
        </div>
      )
  }


};



const styles = theme => ({
  root: {
    width: "90%"
  }
});
export default withStyles(styles)(PackageConfirmationComponent);
//export default  PackageConfirmationComponent;



